<script setup>
import Quote from './components/Quote.vue';

</script>

<template>
    <Quote></Quote>
</template>
